import * as MARKETviewApi from 'api/market-view-api';
import * as StrapiApi from 'api/strapi-api';
import * as ProductsApi from 'api/products-api';
import * as ReportsApi from 'api/reports-api';

const apiBundle = {
  ...MARKETviewApi,
  ...StrapiApi,
  ...ProductsApi,
  ...ReportsApi,
};

export type ApiBundle = typeof apiBundle;

export default apiBundle;
